// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3qxaf","section":"styles__section___VFxxr"};